/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_LoggingInputs */

const en_svchip_logging = /** @type {(inputs: Svchip_LoggingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logging`)
};

const ar_svchip_logging = /** @type {(inputs: Svchip_LoggingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التسجيل`)
};

const bn_svchip_logging = /** @type {(inputs: Svchip_LoggingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`লগিং`)
};

const de_svchip_logging = /** @type {(inputs: Svchip_LoggingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protokollierung`)
};

const es_svchip_logging = /** @type {(inputs: Svchip_LoggingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro`)
};

const fr_svchip_logging = /** @type {(inputs: Svchip_LoggingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Journalisation`)
};

const pt_svchip_logging = /** @type {(inputs: Svchip_LoggingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro em log`)
};

const zh_svchip_logging = /** @type {(inputs: Svchip_LoggingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日志记录`)
};

const tr_svchip_logging = /** @type {(inputs: Svchip_LoggingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logging`)
};

const ru_svchip_logging = /** @type {(inputs: Svchip_LoggingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ведение журнала`)
};

const pl_svchip_logging = /** @type {(inputs: Svchip_LoggingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejestrowanie`)
};

/**
* | output |
* | --- |
* | "Logging" |
*
* @param {Svchip_LoggingInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_logging = /** @type {((inputs?: Svchip_LoggingInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_LoggingInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_logging(inputs)
	if (locale === "bn") return bn_svchip_logging(inputs)
	if (locale === "de") return de_svchip_logging(inputs)
	if (locale === "es") return es_svchip_logging(inputs)
	if (locale === "fr") return fr_svchip_logging(inputs)
	if (locale === "pt") return pt_svchip_logging(inputs)
	if (locale === "zh") return zh_svchip_logging(inputs)
	if (locale === "tr") return tr_svchip_logging(inputs)
	if (locale === "ru") return ru_svchip_logging(inputs)
	if (locale === "pl") return pl_svchip_logging(inputs)
	return en_svchip_logging(inputs)
});